import strings from 'utils/strings'

export const RPDuplicationErrorCodes = {
  '400': strings.ref_param_dup_error_incomplete_info,
  '428': strings.ref_param_dup_error_status,
  '403': strings.ref_param_dup_errorforbidden,
}
